import { render, staticRenderFns } from "./DownloadLUTButton.vue?vue&type=template&id=7ddc9f52&"
import script from "./DownloadLUTButton.vue?vue&type=script&lang=js&"
export * from "./DownloadLUTButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports